// AppModalType is used to identify the type of modal to be displayed
export const AppModalType = {
    IDLE_MODAL: 'IDLE_MODAL',
    SESSION_EXPIRED_MODAL: 'SESSION_EXPIRED_MODAL',
};
